import { channel } from ".."

export function getCurrentModuleMode(): string | undefined {
    return channel("GLOBAL").last(1, "MVC/RESIZE")[0]?.content?.moduleMode
}
